import { useMutation } from '@tanstack/react-query'
import { createAccountUser } from 'services/AccountService'

export const useCreateAccountUserMutation = () => {
  return useMutation({ mutationFn: createAccountUser })
}
